import {
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  styled,
} from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import SwapHorizIcon from "@material-ui/icons/SwapHoriz";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { linkToEpocusHome, linkToEpocusReview } from "../links";
import { EPOCUS_TEXT_SECONDARY } from "./epocus-palette";
import { hasWorkModeSwitch } from "./epocus-role-variant";
import {
  type EpocusWorkMode,
  setEpocusWorkMode,
  useEpocusWorkMode,
} from "./epocus-work-mode";
import { useEpocusRole } from "./rbac/epocus-claim";

const WORK_MODE_LABELS: Record<EpocusWorkMode, string> = {
  clinical: "Clinical",
  qa: "QA",
};

const WORK_MODES: ReadonlyArray<EpocusWorkMode> = ["clinical", "qa"];

const SwitchButton = styled(IconButton)({
  color: EPOCUS_TEXT_SECONDARY,
});

const CheckSlot = styled(ListItemIcon)({
  minWidth: 28,
});

export const WorkModeSwitch: FC<{ opensUpward?: boolean }> = ({
  opensUpward,
}) => {
  const role = useEpocusRole();
  const mode = useEpocusWorkMode();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  if (!hasWorkModeSwitch(role)) return null;

  const label = `Switch work mode (now ${WORK_MODE_LABELS[mode]})`;

  return (
    <>
      <SwitchButton
        aria-label={label}
        title={label}
        aria-haspopup="menu"
        size="small"
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        <SwapHorizIcon />
      </SwitchButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: opensUpward ? "top" : "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: opensUpward ? "bottom" : "top",
          horizontal: "right",
        }}
      >
        {WORK_MODES.map((key) => (
          <MenuItem
            key={key}
            role="menuitemradio"
            aria-checked={key === mode}
            selected={key === mode}
            onClick={() => {
              setAnchorEl(null);
              setEpocusWorkMode(key);
              navigate(
                key === "qa" ? linkToEpocusReview() : linkToEpocusHome(),
              );
            }}
          >
            <CheckSlot>
              {key === mode ? <CheckIcon fontSize="small" /> : null}
            </CheckSlot>
            {WORK_MODE_LABELS[key]}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
